import {Edit} from "@mui/icons-material";
import React, {useState} from "react";
import Grid from "../../../../components/dialogs/Grid";
import TextField from "../../../../components/fields/textfield/TextField";
import SectionActionBar from "../../../../components/section/SectionActionBar";
import {SectionActionButton} from "../../../../components/section/SectionActionButton";
import SectionHeader from "../../../../components/section/SectionHeader";
import {t} from "../../../../store/localization/TranslMessasge";
import {CommonTranslationKey} from "../CommonTranslationKey";
import {UserGroupDto} from "../../../../common/apis/usergroup/UserGroupDto";
import {UserGroupsTranslationKey} from "./UserGroupsTranslationKey";
import UserGroupEditDialog from "./UserGroupEditDialog";

interface UserGroupBasicInfoPanelProps {
    userGroup: UserGroupDto;
    onUpdated: () => void;
}

export default function UserGroupBasicInfoPanel({userGroup, onUpdated}: Readonly<UserGroupBasicInfoPanelProps>) {
    const [editDialogOpen, setEditDialogOpen] = useState(false);

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <SectionHeader title={t(UserGroupsTranslationKey.DETAILS)}>
                        <SectionActionBar>
                            <SectionActionButton
                                icon={<Edit fontSize="inherit"/>}
                                tooltip={t(CommonTranslationKey.EDIT)}
                                onClick={() => setEditDialogOpen(true)}/>
                        </SectionActionBar>
                    </SectionHeader>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        id="user-group-detail-name"
                        label={t(UserGroupsTranslationKey.NAME)}
                        value={userGroup.name}
                        readOnly={true}/>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        id="user-group-detail-description"
                        label={t(UserGroupsTranslationKey.DESCRIPTION)}
                        value={userGroup.description || ""}
                        readOnly={true}
                        multiline
                        rows={4}/>
                </Grid>
            </Grid>

            {editDialogOpen &&
                <UserGroupEditDialog
                    userGroup={userGroup}
                    onClose={() => setEditDialogOpen(false)}
                    onGroupUpdated={() => onUpdated()}
                />
            }
        </>
    );
}
